import { render, staticRenderFns } from "./RecentServiceProviderActivities.vue?vue&type=template&id=777b31fc&scoped=true"
import script from "./RecentServiceProviderActivities.vue?vue&type=script&lang=js"
export * from "./RecentServiceProviderActivities.vue?vue&type=script&lang=js"
import style0 from "./RecentServiceProviderActivities.vue?vue&type=style&index=0&id=777b31fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777b31fc",
  null
  
)

export default component.exports